<mat-list-item [ngClass]="classItem()">
  @if (tooltip() != null) {
    <label matTooltipClass="tooltip-info" #matTooltip="matTooltip" (click)="matTooltip.toggle()" [matTooltip]="tooltip()" [ngClass]="classLabel()">
      <span>{{label()}}</span>
    </label>
  }
  @if (tooltip() == null) {
    <label [ngClass]="classLabel()">{{label()}}</label>
  }
  @switch (type()) {
    @case ('digits') {
      <span class="value" [ngClass]="classValue()">{{value() != null ? value() : "-"}}@if (suffixWithSpace() != null) {
        <span [innerHTML]="suffixWithSpace()"></span>
      }</span>
    }
    @case ('decimal') {
      <span class="value" [ngClass]="classValue()">{{value() != null ? value() : "-"}}@if (suffixWithSpace() != null) {
        <span [innerHTML]="suffixWithSpace()"></span>
      }</span>
    }
    @case ('financial') {
      <span class="value" [ngClass]="classValue()">{{value() != null ? (value() | currency:'EUR':'symbol':'1.0-0') : "-"}}@if (suffixWithSpace() != null) {
        <span [innerHTML]="suffixWithSpace()"></span>
      }</span>
    }
    @case ('financial-2') {
      <span class="value" [ngClass]="classValue()">{{value() != null ? (value() | currency:'EUR':'symbol':'1.2-2') : "-"}}@if (suffixWithSpace() != null) {
        <span [innerHTML]="suffixWithSpace()"></span>
      }</span>
    }
    @case ('percentage') {
      <span class="value" [ngClass]="classValue()">{{value() != null ? (value() | number:'1.1-2') : "-"}} %@if (suffixWithSpace() != null) {
        <span [innerHTML]="suffixWithSpace()"></span>
      }</span>
    }
    @case ('date') {
      <span class="value" [ngClass]="classValue()">{{value() != null ? (value().toString() | date:'longDate') : "-"}}</span>
    }
    @case ('text') {
      <span class="value" [ngClass]="classValue()">{{value() != null ? value() : "-"}}</span>
    }
    @case ('boolean') {
      @if (value() && value().toString() === true.toString()) {
        <span class="flex justify-start content-center items-center flex-row">
          <mat-icon color="accent" class="icon-small mr1">check</mat-icon><span translate="">Yes</span>
        </span>
      }
      @if (!value() || value().toString() === false.toString()) {
        <span class="flex justify-start content-center items-center flex-row">
          <mat-icon color="warn" class="icon-small">clear</mat-icon><span translate="">No</span>
        </span>
      }
      @if (value() === null) {
        <span class="value" translate="">None</span>
      }
    }
    @case ('none') {
      <span class="value"></span>
    }
  }
  <ng-content></ng-content>
</mat-list-item>
